Customer.Ticket ||= {}

class Customer.Ticket.LoadingTicketView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/loading_ticket']

  initialize: (@options = {}) ->
    @ticketId = @options.ticketId
    @ticketType = @options.ticketType
    @fetchAndOpenTicketWithId(@ticketId)
    @counter = 0

  render: =>
    @$el.html(@template())
    @

  onCloseTab: =>
    #Esto es para compatibilidad con SummaryView

  showIsTyping: ->
    # for compatibility with TicketView

  fetchAndOpenTicketWithId: (ticketId) =>
    ticketToOpen = new Customer.Ticket({id: ticketId}, @options.tags)
    ticketToOpen.fetch({
      silent: true
      global: false
      data: { page: 1 }
      success: (ticket) =>
        @trigger('ticket:finished-loading', ticket, @tabId())
    })

  tabName: ->
    @ticketId

  tabId: ->
    @ticketId

  uniqueId: ->
    @ticketId

  iconSelector: ->
    @ticketType

  startFetchingUpdates: ->

  stopFetchingUpdates: ->

  scrollTo: ->

  onAssignTo: ->

  onSelectTab: ->

  onRefreshTab: ->

  currentScrollPosition: ->
